import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }

import { computed, onMounted } from 'vue'
  import { useStore } from '@/store'

  // VUE Components
  import ViewWrapper from '@/components/UI/ViewWrapper.vue'
  import SettingsSection from '@/components/Profile/SettingsSection.vue'
  import InfoSection from '@/components/Profile/InfoSection.vue'

  // Composables

  // Translations
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

  const { t } = useI18n()

  // Store Setup
  const store = useStore()

  // Computed properties for state
  const isLoading = computed(() => {
    // Profile page should only wait for auth-related loading that requires hiding the entire page
    // Exclude updateUserInfo since EditInfoForm has its own loading indicator
    const authLoadingStates = store.state.auth?.loading || {}
    const relevantLoadingActions = ['login', 'refresh', 'register', 'logout']
    
    return relevantLoadingActions.some(action => authLoadingStates[action]) || false
  })

  // onMounted(async () => {})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ViewWrapper, {
    id: "profile",
    title: _unref(t)('profile.pageTitle'),
    class: "w-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(SettingsSection),
              _createVNode(InfoSection)
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})